import { Spinner } from "react-bootstrap";

export const LoadingSpinner = ({ className }: { className?: string }) => {
    return (
        <div
            style={{
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
            }}
        >
            <Spinner animation="border" className={className}>
                <output className="visually-hidden">Loading...</output>
            </Spinner>
        </div>
    );
};
